// src/hooks/useAutoRecalculate.ts
"use client";

import { useEffect } from "react";
import { Stops } from "@/types/trip.types";

interface UseAutoRecalculateProps {
  shouldRecalculate: boolean;
  setShouldRecalculate: (v: boolean) => void;
  stops: Stops;
  setTripLoading: (v: boolean) => void;
  planTrip: (stops: Stops) => Promise<void> | void;
}

export function useAutoRecalculate({
  shouldRecalculate,
  setShouldRecalculate,
  stops,
  setTripLoading,
  planTrip,
}: UseAutoRecalculateProps) {
  useEffect(() => {
    if (!shouldRecalculate) return;
    if (stops.length <= 1) {
      setShouldRecalculate(false);
      return;
    }

    const allValid = stops.every(s => s.coords.latitude !== 0 && s.coords.longitude !== 0);

    if (allValid) {
      setTripLoading(true);
      void planTrip(stops);
    }

    setShouldRecalculate(false);
  }, [shouldRecalculate, stops, planTrip, setTripLoading, setShouldRecalculate]);
}
